// extracted by mini-css-extract-plugin
export default {"marqueeContainer":"Marquee_marqueeContainer__oYBxV","marquee":"Marquee_marquee__yuBtB","initialMarquee":"Marquee_initialMarquee__cHCcL","marquee2":"Marquee_marquee2__+gr-l"};